export const REPORT_ADMIN_REQUEST = 'REPORT_ADMIN_REQUEST'
export const REPORT_ADMIN_SUCCESS = 'REPORT_ADMIN_SUCCESS'
export const REPORT_ADMIN_FAIL = 'REPORT_ADMIN_FAIL'
